module.exports = __webpack_public_path__ + "img/ug.abab7fff.svg";